/* CSS variables. You need to handle all places where `CSS variables` are marked. */

import { LINE_COLORS } from '@blocksuite/hive-model';
import {
  type HiveCssVariables,
  type HiveTheme,
  cssVar,
} from '@toeverything/theme';
export { cssVar } from '@toeverything/theme';
import { type HiveThemeKeyV2, cssVarV2 } from '@toeverything/theme/v2';
import { unsafeCSS } from 'lit';
export { cssVarV2 } from '@toeverything/theme/v2';
export const ColorVariables = [
  '--hive-brand-color',
  '--hive-primary-color',
  '--hive-secondary-color',
  '--hive-tertiary-color',
  '--hive-hover-color',
  '--hive-icon-color',
  '--hive-icon-secondary',
  '--hive-border-color',
  '--hive-divider-color',
  '--hive-placeholder-color',
  '--hive-quote-color',
  '--hive-link-color',
  '--hive-edgeless-grid-color',
  '--hive-success-color',
  '--hive-warning-color',
  '--hive-error-color',
  '--hive-processing-color',
  '--hive-text-emphasis-color',
  '--hive-text-primary-color',
  '--hive-text-secondary-color',
  '--hive-text-disable-color',
  '--hive-black-10',
  '--hive-black-30',
  '--hive-black-50',
  '--hive-black-60',
  '--hive-black-80',
  '--hive-black-90',
  '--hive-black',
  '--hive-white-10',
  '--hive-white-30',
  '--hive-white-50',
  '--hive-white-60',
  '--hive-white-80',
  '--hive-white-90',
  '--hive-white',
  '--hive-background-code-block',
  '--hive-background-tertiary-color',
  '--hive-background-processing-color',
  '--hive-background-error-color',
  '--hive-background-warning-color',
  '--hive-background-success-color',
  '--hive-background-primary-color',
  '--hive-background-secondary-color',
  '--hive-background-modal-color',
  '--hive-background-overlay-panel-color',
  '--hive-tag-blue',
  '--hive-tag-green',
  '--hive-tag-teal',
  '--hive-tag-white',
  '--hive-tag-purple',
  '--hive-tag-red',
  '--hive-tag-pink',
  '--hive-tag-yellow',
  '--hive-tag-orange',
  '--hive-tag-gray',
  ...LINE_COLORS,
  '--hive-tooltip',
  '--hive-blue',
];

export const SizeVariables = [
  '--hive-font-h-1',
  '--hive-font-h-2',
  '--hive-font-h-3',
  '--hive-font-h-4',
  '--hive-font-h-5',
  '--hive-font-h-6',
  '--hive-font-base',
  '--hive-font-sm',
  '--hive-font-xs',
  '--hive-line-height',
  '--hive-z-index-modal',
  '--hive-z-index-popover',
];

export const FontFamilyVariables = [
  '--hive-font-family',
  '--hive-font-number-family',
  '--hive-font-code-family',
];

export const StyleVariables = [
  '--hive-editor-width',

  '--hive-theme-mode',
  '--hive-editor-mode',
  /* --hive-palette-transparent: special values added for the sake of logical consistency. */
  '--hive-palette-transparent',

  '--hive-popover-shadow',
  '--hive-menu-shadow',
  '--hive-float-button-shadow',
  '--hive-shadow-1',
  '--hive-shadow-2',
  '--hive-shadow-3',

  '--hive-paragraph-space',
  '--hive-popover-radius',
  '--hive-scale',
  ...SizeVariables,
  ...ColorVariables,
  ...FontFamilyVariables,
] as const;

type VariablesType = typeof StyleVariables;
export type CssVariableName = Extract<
  VariablesType[keyof VariablesType],
  string
>;

export type CssVariablesMap = Record<CssVariableName, string>;

export const unsafeCSSVar = (
  key: keyof HiveCssVariables | keyof HiveTheme,
  fallback?: string
) => unsafeCSS(cssVar(key, fallback));

export const unsafeCSSVarV2 = (key: HiveThemeKeyV2, fallback?: string) =>
  unsafeCSS(cssVarV2(key, fallback));
